import React, { useContext, useState } from "react";
import { Box, Button, Stack } from "@mui/material";
import { MyDialog } from "../../component/index";
import DataSourceContext from "../../context/DataSourceMngContext";
import MyAutocomplete from "../../component/input/autocomplete";

export default function DialogNewTraining() {
  const { dialog, loading } = useContext(DataSourceContext);
  return (
    <MyDialog
      Header={`Select type`}
      maxHeight={250}
      minWidth={400}
      open={dialog.new_training}
      loading={loading.modal}
      actionContent={false}
    >
      <SelectionType />
    </MyDialog>
  );
}

const SelectionType = () => {

  const [selectedType, setSelectedType] = useState(null);
  const { setDataState, selectServer } = useContext(DataSourceContext);

  const handleSelectTypeChange = (event, newValue) => {
    setSelectedType(newValue);
  };

  const handleCancel = () => {
    setDataState((prevState) => ({
      ...prevState,
      dialog: {
        ...prevState.dialog,
        new_training: false,
        annotate: false,
      },
    }));
  };

  const handleConfirm = async () => {
    setDataState((prevState) => ({
      ...prevState,
      dialog: {
        ...prevState.dialog,
        annotate: true,
        new_training: false,
      },
    }));
  };

  return (
    <Box>
        <Stack direction="row" spacing={1} sx={{ width: "100%" }}>
          <MyAutocomplete
            fullWidth
            options={selectServer?.option}
            getOptionLabel={(option) => option.name}
            onChange={handleSelectTypeChange}
          />
        </Stack>
        <Box
        sx={{
          position: "absolute",
          bottom: 0,
          left: 0,
          display: "flex",
          gap: 2,
          width: "100%",
          paddingBottom: 2,
          justifyContent: "center",
        }}
      >
        {/* {!selectedFiles && ( */}
          <>
            <Button
              variant="outlined"
              onClick={handleCancel}
              sx={{ width: "40%", height: "40px" }}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={handleConfirm}
              sx={{ width: "40%", height: "40px" }}
              disabled={!selectedType}
            >
              Confirm
            </Button>
          </>
        {/* )} */}
      </Box>
    </Box>
  );
};
